import alarmAlert from 'app/assets/images/alarm-alert.svg';
import efficiencyFull from 'app/assets/images/efficiency.png';
import efficiencyFullWebp from 'app/assets/images/efficiency.webp';
import efficiencyCompressed from 'app/assets/images/efficiency-compressed.png';
import efficiencyCompressedWebp from 'app/assets/images/efficiency-compressed.webp';
import emailSent from 'app/assets/images/email-sent.svg';
import globalSearchEmptyResults from 'app/assets/images/global-search-empty-results.png';
import globalSearchNewSearch from 'app/assets/images/global-search-new-search.png';
import globalSearchNoLoadData from 'app/assets/images/global-search-no-load-data.png';
import invoice from 'app/assets/images/invoice.svg';
import loadPayIcon from 'app/assets/images/lp-icon.svg';
import noaBackgroundFull from 'app/assets/images/noa_background.jpg';
import noaBackgroundFullWebp from 'app/assets/images/noa_background.webp';
import noaBackgroundCompressed from 'app/assets/images/noa_background-compressed.jpg';
import noaBackgroundCompressedWebp from 'app/assets/images/noa_background-compressed.webp';
import phone from 'app/assets/images/phone.png';
import phoneSvg from 'app/assets/images/phone.svg';
import phoneWebp from 'app/assets/images/phone.webp';
import qpPromotionBgFull from 'app/assets/images/qp_promotion_bg.png';
import qpPromotionBgFullWebp from 'app/assets/images/qp_promotion_bg.webp';
import qpPromotionBgCompressed from 'app/assets/images/qp_promotion_bg-compressed.png';
import qpPromotionBgCompressedWebp from 'app/assets/images/qp_promotion_bg-compressed.webp';
import selectCarrierBadge from 'app/assets/images/sc-badge-large.svg';
import selectCarrierBadgeBlackWhite from 'app/assets/images/sc-badge-large-bw.svg';
import selectCarrierBadgeMdBlackWhiteFilled from 'app/assets/images/sc-badge-md-bw-filled.png';
import selectCarrierBadgeSmall from 'app/assets/images/sc-badge-small.svg';
import selectCarrierBadgeSmallDisabled from 'app/assets/images/sc-badge-small-disabled.png';
import selectCarrierFactoredBadgeSmall from 'app/assets/images/sc-factored-badge-small.svg';
import shield from 'app/assets/images/shield.svg';
import stopPayments from 'app/assets/images/stop-payments.svg';
import stopSign from 'app/assets/images/stop-sign.svg';
import logoNewLightFull from 'app/assets/images/triumph_logo.svg';
import logoNewFull from 'app/assets/images/triumph_logo_light.svg';
import mobileLogoNewFull from 'app/assets/images/triumph_mobile.svg';
import truck1Full from 'app/assets/images/truck-1-20230414.png';
import truck1FullWebp from 'app/assets/images/truck-1-20230414.webp';
import truck1Compressed from 'app/assets/images/truck-1-compressed-20230414.png';
import truck1CompressedWebp from 'app/assets/images/truck-1-compressed-20230414.webp';
import truck2Full from 'app/assets/images/truck-2.png';
import truck2FullWebp from 'app/assets/images/truck-2.webp';
import truck2Compressed from 'app/assets/images/truck-2-compressed.png';
import truck2CompressedWebp from 'app/assets/images/truck-2-compressed.webp';
import trucker1Full from 'app/assets/images/trucker-1-20230414.png';
import trucker1FullWebp from 'app/assets/images/trucker-1-20230414.webp';
import trucker1Compressed from 'app/assets/images/trucker-1-compressed-20230414.png';
import trucker1CompressedWebp from 'app/assets/images/trucker-1-compressed-20230414.webp';
import trucker2Full from 'app/assets/images/trucker-2-20230414.png';
import trucker2FullWebp from 'app/assets/images/trucker-2-20230414.webp';
import trucker2Compressed from 'app/assets/images/trucker-2-compressed-20230414.png';
import trucker2CompressedWebp from 'app/assets/images/trucker-2-compressed-20230414.webp';
import trucker3Full from 'app/assets/images/trucker-3-20230414.png';
import trucker3FullWebp from 'app/assets/images/trucker-3-20230414.webp';
import trucker3Compressed from 'app/assets/images/trucker-3-compressed-20230414.png';
import trucker3CompressedWebp from 'app/assets/images/trucker-3-compressed-20230414.webp';
import trucker4Full from 'app/assets/images/trucker-4-20230414.png';
import trucker4FullWebp from 'app/assets/images/trucker-4-20230414.webp';
import trucker4Compressed from 'app/assets/images/trucker-4-compressed-20230414.png';
import trucker4CompressedWebp from 'app/assets/images/trucker-4-compressed-20230414.webp';
import welcome from 'app/assets/images/welcome.svg';
import yieldSign from 'app/assets/images/yield-sign.svg';
import yieldSignBasic from 'app/assets/images/yield-sign-basic.svg';
import { getBrowserSupport } from 'app/utils/lib/getBrowserSupport';

const isWebpSupported = getBrowserSupport('webp');

export const images = {
  alarmAlert: {
    compressed: alarmAlert,
    full: alarmAlert,
  },
  efficiency: {
    compressed: isWebpSupported ? efficiencyCompressedWebp : efficiencyCompressed,
    full: isWebpSupported ? efficiencyFullWebp : efficiencyFull,
  },
  emailSent: {
    compressed: emailSent,
    full: emailSent,
  },
  globalSearchEmptyResults: {
    compressed: globalSearchEmptyResults,
    full: globalSearchEmptyResults,
  },
  globalSearchNewSearch: {
    compressed: globalSearchNewSearch,
    full: globalSearchNewSearch,
  },
  globalSearchNoLoadData: {
    compressed: globalSearchNoLoadData,
    full: globalSearchNoLoadData,
  },
  invoice: {
    compressed: invoice,
    full: invoice,
  },
  loadPayIcon: {
    compressed: loadPayIcon,
    full: loadPayIcon,
  },
  logoNew: {
    full: logoNewFull,
  },
  logoNewLight: {
    full: logoNewLightFull,
  },
  mobileLogoNew: {
    full: mobileLogoNewFull,
  },
  noaBackground: {
    compressed: isWebpSupported ? noaBackgroundCompressedWebp : noaBackgroundCompressed,
    full: isWebpSupported ? noaBackgroundFullWebp : noaBackgroundFull,
  },
  phone: {
    compressed: isWebpSupported ? phoneWebp : phone,
    full: isWebpSupported ? phoneWebp : phone,
  },
  phoneSvg: {
    compressed: phoneSvg,
    full: phoneSvg,
  },
  qpPromotionBg: {
    compressed: isWebpSupported ? qpPromotionBgCompressedWebp : qpPromotionBgCompressed,
    full: isWebpSupported ? qpPromotionBgFullWebp : qpPromotionBgFull,
  },
  selectCarrier: {
    compressed: selectCarrierBadge,
    full: selectCarrierBadge,
  },
  selectCarrierBadgeSmall: {
    compressed: selectCarrierBadgeSmall,
    full: selectCarrierBadgeSmall,
  },
  selectCarrierBadgeSmallDisabled: {
    compressed: selectCarrierBadgeSmallDisabled,
    full: selectCarrierBadgeSmallDisabled,
  },
  selectCarrierBlackWhite: {
    compressed: selectCarrierBadgeBlackWhite,
    full: selectCarrierBadgeBlackWhite,
  },
  selectCarrierBlackWhiteFilled: {
    compressed: selectCarrierBadgeMdBlackWhiteFilled,
    full: selectCarrierBadgeMdBlackWhiteFilled,
  },
  selectCarrierFactoredBadgeSmall: {
    compressed: selectCarrierFactoredBadgeSmall,
    full: selectCarrierFactoredBadgeSmall,
  },
  shield: {
    compressed: shield,
    full: shield,
  },
  stopPayments: {
    compressed: stopPayments,
    full: stopPayments,
  },
  stopSign: {
    compressed: stopSign,
    full: stopSign,
  },
  truck1: {
    compressed: isWebpSupported ? truck1CompressedWebp : truck1Compressed,
    full: isWebpSupported ? truck1FullWebp : truck1Full,
  },
  truck2: {
    compressed: isWebpSupported ? truck2CompressedWebp : truck2Compressed,
    full: isWebpSupported ? truck2FullWebp : truck2Full,
  },
  trucker1: {
    compressed: isWebpSupported ? trucker1CompressedWebp : trucker1Compressed,
    full: isWebpSupported ? trucker1FullWebp : trucker1Full,
  },
  trucker2: {
    compressed: isWebpSupported ? trucker2CompressedWebp : trucker2Compressed,
    full: isWebpSupported ? trucker2FullWebp : trucker2Full,
  },
  trucker3: {
    compressed: isWebpSupported ? trucker3CompressedWebp : trucker3Compressed,
    full: isWebpSupported ? trucker3FullWebp : trucker3Full,
  },
  trucker4: {
    compressed: isWebpSupported ? trucker4CompressedWebp : trucker4Compressed,
    full: isWebpSupported ? trucker4FullWebp : trucker4Full,
  },
  welcome: {
    compressed: welcome,
    full: welcome,
  },
  yieldSign: {
    compressed: yieldSign,
    full: yieldSign,
  },
  yieldSignBasic: {
    compressed: yieldSignBasic,
    full: yieldSignBasic,
  },
} as const;
